import { computed, ref } from 'vue'

import { useUiStore, type ThemePreference } from '@/shared/ui/store/uiStore'

// Tracks the OS preference reactively so `theme: 'system'` follows live changes.
const prefersDark = ref(false)
if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  const mq = window.matchMedia('(prefers-color-scheme: dark)')
  prefersDark.value = mq.matches
  mq.addEventListener('change', (event) => {
    prefersDark.value = event.matches
  })
}

/** Read/control the theme. Stamping `data-theme` on <html> is wired once in App.vue. */
export function useTheme() {
  const store = useUiStore()
  const resolvedTheme = computed<'light' | 'dark'>(() =>
    store.theme === 'system' ? (prefersDark.value ? 'dark' : 'light') : store.theme,
  )
  return {
    theme: computed(() => store.theme),
    resolvedTheme,
    setTheme: (value: ThemePreference) => store.setTheme(value),
  }
}
